import React, { Fragment } from 'react';
import { connect } from '../../redux/store';
import { compose, withHandlers, lifecycle } from 'recompose';
import { CoreForm } from '@kineticdata/react';
import {
  LoadingMessage,
  ErrorMessage,
  ErrorNotFound,
  ErrorUnauthorized,
  ErrorUnexpected,
} from '@kineticdata/bundle-common';
import { PageTitle } from '../shared/PageTitle';
import { parse } from 'query-string';
import { Map } from 'immutable';
import { actions } from '../../redux/modules/adminForms';

import { I18n } from '@kineticdata/react';

export const SubmissionComponent = ({
  formSlug,
  id,
  cloneId,
  cloneSubmission,
  cloneSubmissionError,
  form,
  handleSave,
  values,
  fetch,
}) => (
  <Fragment>
    <div className="page-container">
      <div className="page-panel">
        <PageTitle
          parts={[form.name, `Admin Forms`]}
          breadcrumbs={[
            { label: 'Admin Forms', to: `../../..${cloneId ? '/..' : ''}` },
            { label: form.name, to: `../..${cloneId ? '/..' : ''}` },
          ]}
          title={
            <span>
              <I18n>{`${id ? 'Edit' : cloneId ? 'Clone' : 'New'} Record`}</I18n>{' '}
              <small>
                <small>
                  <I18n>for</I18n>
                </small>{' '}
                <I18n>{form.name}</I18n>
              </small>
            </span>
          }
        />

        <I18n context={`kapps.admin.forms.${formSlug}`}>
          <div className="embedded-core-form--wrapper">
            {cloneId ? (
              cloneSubmissionError ? (
                <ErrorMessage message="The submission to clone could not be found." />
              ) : cloneSubmission ? (
                <CoreForm
                  kapp="admin"
                  form={formSlug}
                  created={handleSave}
                  updated={handleSave}
                  completed={handleSave}
                  values={Map(cloneSubmission.values)
                    .filter(Boolean)
                    .toJS()}
                  notFoundComponent={ErrorNotFound}
                  unauthorizedComponent={ErrorUnauthorized}
                  unexpectedErrorComponent={ErrorUnexpected}
                />
              ) : (
                <LoadingMessage />
              )
            ) : id ? (
              <CoreForm
                submission={id}
                updated={handleSave}
                completed={handleSave}
              />
            ) : (
              <CoreForm
                kapp="admin"
                form={formSlug}
                created={handleSave}
                updated={handleSave}
                completed={handleSave}
                values={values}
                notFoundComponent={ErrorNotFound}
                unauthorizedComponent={ErrorUnauthorized}
                unexpectedErrorComponent={ErrorUnexpected}
              />
            )}
          </div>
        </I18n>
      </div>
    </div>
  </Fragment>
);

const valuesFromQueryParams = queryParams => {
  const params = parse(queryParams);
  return Object.entries(params).reduce((values, [key, value]) => {
    if (key.startsWith('values[')) {
      const vk = key.match(/values\[(.*?)\]/)[1];
      return { ...values, [vk]: value };
    }
    return values;
  }, {});
};

export const handleSave = props => response => {
  props.fetchSubmissionsRequest({ formSlug: props.formSlug });
  props.navigate(`../..${props.cloneId ? '/..' : ''}`);
};

export const mapStateToProps = (state, props) => ({
  form: state.adminForms.form,
  values: valuesFromQueryParams(state.router.location.search),
  cloneSubmission: state.adminForms.cloneSubmission,
  cloneSubmissionError: state.adminForms.cloneSubmissionError,
});

const mapDispatchToProps = {
  fetchSubmissionsRequest: actions.fetchSubmissionsRequest,
  fetchCloneSubmissionRequest: actions.fetchCloneSubmissionRequest,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({ handleSave }),
  lifecycle({
    componentDidMount() {
      if (this.props.cloneId) {
        this.props.fetchCloneSubmissionRequest({ id: this.props.cloneId });
      }
    },
    componentDidUpdate(prevProps) {
      if (this.props.cloneId && this.props.cloneId !== prevProps.cloneId) {
        this.props.fetchCloneSubmissionRequest({ id: this.props.cloneId });
      }
    },
  }),
);

export const Submission = enhance(SubmissionComponent);
